import styles from './CardOffer.module.scss';
import stylesCard from './Card.module.scss';
import { Link } from 'react-router';
import { OfferType } from '../App';
import axios from 'axios';
import { offersApiUrl } from '../user-config';


type Props = {
  index: number,
  offer: OfferType,
  setOffers: React.Dispatch<React.SetStateAction<OfferType[]>>
};


export const CardOffer: React.FC<Props> = ({ index, offer, setOffers }) => {

  const postScroll = document.getElementById("offerItems" + index);
  let scrollingHorizontally = true;

  const deleteOffer = (offerId: string) => {
    axios.delete(`${offersApiUrl}/${offer.offerId}`)
      .then(() => {
        setOffers(prev => [...prev.filter(item => !(item.offerId === offerId))]);
        alert("Успешно удалено");
      })
      .catch(error => { alert("!!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !! \nПроизошла ошибка. \nНе удалось удалить КП \n!!! !!! !!! !!! !!! !!! !!! !!! !!!"); console.error(error) });
  };


  postScroll?.addEventListener("wheel", (event) => {
    if (scrollingHorizontally) {
      postScroll.scrollBy({
        left: event.deltaY < 0 ? -20 : 20,
      });
      event.preventDefault();
    };
  });

  var date = new Date(offer.createdAt * 1000);
  var months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
  var year = date.getFullYear();
  var month = months[date.getMonth()];
  var day = date.getDate();


  return (
    <div className={styles.wrapper}>
      <article className={stylesCard.Card + " " + styles.CardOffer}>

        <button className={stylesCard.btn + " " + styles.btn} onClick={() => deleteOffer(offer.offerId)}>
          <img src="assets/img/icons/cart.svg" alt="cart" />
        </button>

        <ul className={styles.infoBlock}>
          <Link
            className={styles.Link}
            to={{
              pathname: "/",
              search: "?ofId=" + offer.offerId,
            }}
          >
            {offer.client && <li>Клиент: {offer.client}</li>}
            <li>Создано: {day} {month} {year} г.</li>
            {offer.manager && <li>Менеджер: {offer.manager}</li>}
          </Link>
        </ul>

        <div className={styles.itemsBlock} id={"offerItems" + index}>
          {
            [...offer.items].map((item, index) =>
              <div className={styles.item} key={index}>
                <img src={item.img_url} alt="Item" />
                <p className={styles.article_id}>
                  {item.article_id}
                </p>
              </div>
            )
          }
        </div>

      </article >
    </div >
  )
}
